<script setup lang="ts">
import { Button } from '@collector/shared-ui'

import SectionTitleButton from './SectionTitleButton.vue'

type Props = {
  label: string
  count?: number
  showButton?: boolean
  buttonText?: string
  buttonConfirmText?: string
}
withDefaults(defineProps<Props>(), {
  count: 0,
  buttonConfirmText: 'Are you sure?',
})

type Emits = {
  actionConfirmed: [void]
}
const emit = defineEmits<Emits>()
</script>

<template>
  <div
    class="bg-neutral-light-8 sticky top-0 flex h-6 items-center justify-between rounded-md p-1 text-sm"
  >
    <div class="font-bold">{{ label }} ({{ count }})</div>
    <SectionTitleButton
      v-if="showButton"
      :text="buttonConfirmText"
      @confirm="emit('actionConfirmed')"
    >
      <Button
        class="text-neutral-dark-8 hover:text-neutral-dark-10 active:text-neutral-light-1 cursor-pointer font-bold transition-none"
      >
        {{ buttonText }}
      </Button>
    </SectionTitleButton>
  </div>
</template>
